class Sponsorship {

    constructor(
        id,
        image_es,
        image_en,
        place_id,
        usage_limit,
        type,
        automatic_habilitation,
        enabled,
        date_to,
        date_from,
        description_es,
        description_en,
        title_es,
        title_en,
        name_es,
        name_en,
        sections,
        evidences
    ) {
        this.id = id || null;
        this.image_es = image_es || null;
        this.image_en = image_en || null;
        this.place_id = place_id || null;
        this.usage_limit = usage_limit || null;
        this.type = type || null;
        this.automatic_habilitation = automatic_habilitation || null;
        this.enabled = enabled || false;
        this.date_to = date_to || null;
        this.date_from = date_from || null;
        this.description_es =  description_es || '';
        this.description_en = description_en || null;
        this.title_es = title_es || '';
        this.title_en = title_en || '';
        this.name_en = name_en || '';
        this.name_es = name_es || '';
        this.sections = sections || [];
        this.evidences = evidences || [];
    }

    static parse( data ) {
        if ( !data ) { return new Sponsorship(); }

        const d = data;

        return new Sponsorship(
            d.id,
            d.image_es,
            d.image_en,
            d.place_id,
            d.usage_limit,
            d.type,
            d.automatic_habilitation,
            d.enabled,
            d.date_to,
            d.date_from,
            d.description_es,
            d.description_en,
            d.title_es,
            d.title_en,
            d.name_es,
            d.name_en,
            d.sections,
            d.evidences
        );
    }

}

export default Sponsorship;


// WEBPACK FOOTER //
// ./src/models/sponsorship.js